export const locationExperiences = (state, rootState, getters, rootGetters) => locationId => {
  return rootGetters['entities/Experience'](experience => experience.location.id === locationId).sort((a, b) => a.order - b.order);
};

export const experienceById = (state, rootState, getters, rootGetters) => experienceId => {
  return rootGetters['entities/Experience'](experienceId);
};
